import { Injectable } from '@angular/core';

import { RequestService } from '../request.service';

@Injectable()
export class VerifyEmailService {
  api = {
    root: '/users/verify',
  };

  constructor(private request: RequestService) {}

  public verify(token: string) {
    return this.request.post({
      uri: this.api.root + '?token=' + token,
      body: {},
      handlers: {
        error: () => void 0,
        success: () => void 0,
      },
    });
  }

  public resend(email: string) {
    return this.request.post({
      uri: this.api.root + '/resend',
      body: { email },
      handlers: {
        error: () => void 0,
        success: () => void 0,
      },
    });
  }
}
